import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  signal,
} from "@angular/core";
import { select, Store } from "@ngxs/store";
import { UserGroup } from "@platform-app/app/core/api/models";
import { AuthState } from "@platform-app/app/core/auth/auth.state";
import { ScreenWidthService } from "@platform-app/app/shared/common/services/screen-width.service";
import { SetA2HSAcknowledged } from "@platform-app/app/shared/common/store/a2hs/a2hs.actions";
import { A2HSState } from "@platform-app/app/shared/common/store/a2hs/a2hs.state";
import { ButtonModule } from "primeng/button";
import { DialogModule } from "primeng/dialog";

interface InstructionStepModel {
  order: number;
  title: string;
  description: string;
  image: string;
}

const IOS_INSTRUCTION_STEPS: InstructionStepModel[] = [
  {
    order: 1,
    title: "Tap your browser's menu or share options",
    description:
      "This is often located at the top or bottom of your screen, commonly represented by a share icon, a 3-dot menu, or a gear icon.",
    image: "assets/images/ios-a2hs-step-1.svg",
  },
  {
    order: 2,
    title: "In the options that appear, find and tap 'Add to Home Screen'.",
    description: "This option may also be labeled 'Install app' or similar.",
    image: "assets/images/ios-a2hs-step-2.svg",
  },
];

@Component({
  selector: "app-a2hs-notification",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DialogModule, ButtonModule],
  templateUrl: "./a2hs-notification.component.html",
  styleUrl: "./a2hs-notification.component.scss",
})
export class A2HSNotificationComponent {
  private readonly screenWidthService = inject(ScreenWidthService);
  private readonly store = inject(Store);

  instructions = IOS_INSTRUCTION_STEPS;

  currentUserRole = select(AuthState.roleGroup);
  instructionsAcknowledged = select(A2HSState.acknowledged);

  visible = signal(false);

  setVisibilityEffect = effect(
    () => {
      if (
        this.screenWidthService.isMobile() &&
        this.screenWidthService.isIOS() &&
        this.currentUserRole() === UserGroup.Student &&
        !this.instructionsAcknowledged()
      ) {
        this.visible.set(true);
        this.setVisibilityEffect.destroy();
      }
    },
    { allowSignalWrites: true, manualCleanup: true },
  );

  onClose() {
    this.store
      .dispatch(new SetA2HSAcknowledged())
      .subscribe(() => this.visible.set(false));
  }
}
